// @flow
import { combineReducers } from 'redux';

import type { ID_TYPE } from '../types/common';
import type { TEMPORARY_EVENT_TYPE } from '../types/temporaryEvents';
import * as common from './common';
import * as types from '../types/temporaryEvents';

export const isActive = (event: TEMPORARY_EVENT_TYPE) => (
  !(event.isCanceled || event.isCompleted) && event.active
);

export type TemporaryEventsState = {
  byId: { [ID_TYPE]: TEMPORARY_EVENT_TYPE },
  order: Array<ID_TYPE>,
};

const byId = common.byId({
  added: [types.TEMPORARY_EVENT_ADDED],
  updated: [
    types.TEMPORARY_EVENT_COMPLETED,
    types.TEMPORARY_EVENT_CANCELLED,
    types.TEMPORARY_EVENT_STARTED,
  ],
  defaultAttributes: {
    isCompleted: false,
    isCanceled: false,
    active: false,
  },
});

const order = common.order({
  added: [types.TEMPORARY_EVENT_ADDED],
  preferPrepend: true,
});

const temporaryEvents = combineReducers({
  byId,
  order,
});


export default temporaryEvents;


// Selectors
export const getTemporaryEvent = (
  state: TemporaryEventsState,
  id: ID_TYPE,
): TEMPORARY_EVENT_TYPE => state.byId[id];

export const getTemporaryEvents = (
  state: TemporaryEventsState,
): Array<TEMPORARY_EVENT_TYPE> => state.order.map(id => getTemporaryEvent(state, id));

export const getActiveTemporaryEvents = (
  state: TemporaryEventsState,
): Array<TEMPORARY_EVENT_TYPE> => getTemporaryEvents(state).filter(event => event.active);

export const getTemporaryEventsByGroup = (
  state: TemporaryEventsState,
  group: string,
): Array<TEMPORARY_EVENT_TYPE> => getTemporaryEvents(state).filter(tEv => tEv.group === group);

export const getActiveTemporaryEventsByGroup = (
  state: TemporaryEventsState,
  group: string,
): Array<TEMPORARY_EVENT_TYPE> => getTemporaryEventsByGroup(state, group).filter(event => event.active);



// WEBPACK FOOTER //
// ./src/scripts/reducers/temporaryEvents.js